import { createStore } from 'effector';

export const $authStatus = createStore(false);

export const $userInfo = createStore(null);
$userInfo.watch((state) => console.log('$userInfo', state));
